import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router-dom";
import Banner from "../Banner/Banner";
import axios from "axios";
import Swal from "sweetalert2";


const Register = () => {
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirm: false,
  });
 const [countries, setCountries] = useState([]);
const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    password: "",
    confirmPassword: "",
    agree: true,
    profile_pic: null,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  useEffect(() => {

    axios.get("https://restcountries.com/v3.1/all?fields=name")
      .then(res => {
        const countryList = res.data
          .map(c => c.name.common)
          .sort((a, b) => a.localeCompare(b));
        setCountries(countryList);
      })
      .catch(err => console.error("Error fetching countries:", err));
  }, []);


// const handleSubmit = async (e) => {
//   e.preventDefault();
//   if (formData.password !== formData.confirmPassword) {
//     Swal.fire("Passwords do not match!", "", "error");
//     return;
//   }
//   try {
//     const payload = new FormData();
//     payload.append("first_name", formData.first_name);
//     payload.append("last_name", formData.last_name);
//     payload.append("email", formData.email);
//     payload.append("phone", formData.phone);
//     payload.append("address", formData.address);
//     payload.append("city", formData.city);
//     payload.append("state", formData.state);
//     payload.append("country", formData.country);
//     payload.append("zip", formData.zip);
//     payload.append("status", 1);
//     payload.append("password", formData.password);
//     if (formData.profile_pic) {
//       payload.append("profile_pic", formData.profile_pic);
//     }

//     const res = await axios.post(
//       "https://vantara.datacubeglobal.com/api/create-customer",
//       payload,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data"
//         }
//       }
//     );
//    if (res.data.status === "success") {
//   Swal.fire("Registration successful!", "", "success");
//   setFormData({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone: "",
//     address: "",
//     city: "",
//     state: "",
//     country: "",
//     zip: "",
//     password: "",
//     confirmPassword: "",
//     agree: true,
//     profile_pic: null,
//   });
// } else {
//   // Handle validation or other errors properly
//   let errorMsg = "Registration failed!";
  
//   if (res.data.message) {
//     errorMsg = res.data.message;
//   }

//   if (res.data.errors) {
//     // Get the first error message from the errors object
//     const firstError = Object.values(res.data.errors)[0][0];
//     errorMsg = firstError || errorMsg;
//   }

//   Swal.fire(errorMsg, "", "error");
// }

//   } catch (err) {
//     Swal.fire("Error registering user!", "", "error");
//     console.error(err);
//   }
// };


const handleSubmit = async (e) => {
  e.preventDefault();
 setLoading(true);

  // 1️⃣ Password check
  if (formData.password !== formData.confirmPassword) {
    Swal.fire("Passwords do not match!", "", "error");
    return;
  }

  try {
    // 2️⃣ Prepare form data
    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== null && value !== undefined && key !== "confirmPassword" && key !== "agree") {
        payload.append(key, value);
      }
    });
    payload.append("status", 1);

    // 3️⃣ Send request
    const res = await axios.post(
      "https://vantara.datacubeglobal.com/api/create-customer",
      payload,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    // 4️⃣ Handle success
    if (res.data.status === "success") {
      Swal.fire("Registration successful!", "", "success");
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        state: "",
        country: "",
        zip: "",
        password: "",
        confirmPassword: "",
        agree: true,
        profile_pic: null,
      });
      navigate("/login");
    } else {
      // 5️⃣ Handle validation errors
      let errorMsg = res.data.message || "Registration failed!";

      if (res.data.errors) {
        const allErrors = Object.values(res.data.errors)
          .flat()
          .join("\n");
        errorMsg = allErrors;
      }

      Swal.fire(errorMsg, "", "error");
    }
  } catch (err) {
    // 6️⃣ Handle server/network errors gracefully
    if (err.response?.data?.errors) {
      const allErrors = Object.values(err.response.data.errors)
        .flat()
        .join("\n");
      Swal.fire(allErrors, "", "error");
    } else if (err.response?.data?.message) {
      Swal.fire(err.response.data.message, "", "error");
    } else {
      Swal.fire("Error registering user!", "", "error");
    }
    console.error(err);
  } finally {
      setLoading(false);
    }
  };


  const navigate = useNavigate(); 
  return (
      <>
    <Banner title="Create An Account" />
    <div className="container py-5" style={{ fontFamily: "'Kumbh Sans', sans-serif" }}>
      <div className="row justify-content-center">
        <div className="col-lg-12">
          <div className="row g-5 align-items-start">
            
            {/* Left: Register Form */}
            <div className="col-md-7 border-end pe-lg-5">
              <h2 className="mb-4 ">Register</h2>
               <form onSubmit={handleSubmit}>
                  {/* First Name */}
                 <div className="row mb-3">
    <div className="col">
      <input
        // type="text"
        className="form-control form-control-lg"
        placeholder="First Name*"
        name="first_name"
        value={formData.first_name}
        onChange={handleChange}
        required
      />
    </div>
    <div className="col">
      <input
        // type="text"
        className="form-control form-control-lg"
        placeholder="Last Name*"
        name="last_name"
        value={formData.last_name}
        onChange={handleChange}
        required
      />
    </div>
  </div>
                  {/* Email */}
                   <div className="row mb-3">
    <div className="col">
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      placeholder="Email*"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {/* Phone */}
               <div className="col">
                    <input
                      // type="text"
                      className="form-control form-control-lg"
                      placeholder="Phone*"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  </div>
                  {/* Address */}
                  <div className="mb-3">
                    <textarea
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </div>
                  {/* City */}
                 <div className="row mb-3">
    <div className="col">
                    <input
                      // type="text"
                      className="form-control form-control-lg"
                      placeholder="City"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                    />
                  </div>
                  {/* State */}
                 <div className="col">
                    <select
  className="form-control border-1 rounded-3"
  name="state"
  value={formData.state}
  onChange={handleChange}
>
 <option value="Andhra Pradesh (AP)">Andhra Pradesh (AP)</option>
<option value="Arunachal Pradesh (AR)">Arunachal Pradesh (AR)</option>
<option value="Assam (AS)">Assam (AS)</option>
<option value="Bihar (BR)">Bihar (BR)</option>
<option value="Chhattisgarh (CG)">Chhattisgarh (CG)</option>
<option value="Goa (GA)">Goa (GA)</option>
<option value="Gujarat (GJ)">Gujarat (GJ)</option>
<option value="Haryana (HR)">Haryana (HR)</option>
<option value="Himachal Pradesh (HP)">Himachal Pradesh (HP)</option>
<option value="Jharkhand (JH)">Jharkhand (JH)</option>
<option value="Karnataka (KA)">Karnataka (KA)</option>
<option value="Kerala (KL)">Kerala (KL)</option>
<option value="Madhya Pradesh (MP)">Madhya Pradesh (MP)</option>
<option value="Maharashtra (MH)">Maharashtra (MH)</option>
<option value="Manipur (MN)">Manipur (MN)</option>
<option value="Meghalaya (ML)">Meghalaya (ML)</option>
<option value="Mizoram (MZ)">Mizoram (MZ)</option>
<option value="Nagaland (NL)">Nagaland (NL)</option>
<option value="Odisha (OD)">Odisha (OD)</option>
<option value="Punjab (PB)">Punjab (PB)</option>
<option value="Rajasthan (RJ)">Rajasthan (RJ)</option>
<option value="Sikkim (SK)">Sikkim (SK)</option>
<option value="Tamil Nadu (TN)">Tamil Nadu (TN)</option>
<option value="Telangana (TS)">Telangana (TS)</option>
<option value="Tripura (TR)">Tripura (TR)</option>
<option value="Uttar Pradesh (UP)">Uttar Pradesh (UP)</option>
<option value="Uttarakhand (UK)">Uttarakhand (UK)</option>
<option value="West Bengal (WB)">West Bengal (WB)</option>


<option value="Andaman and Nicobar Islands (AN)">Andaman and Nicobar Islands (AN)</option>
<option value="Chandigarh (CH)">Chandigarh (CH)</option>
<option value="Dadra and Nagar Haveli and Daman and Diu (DN)">
  Dadra and Nagar Haveli and Daman and Diu (DN)
</option>
<option value="Delhi (DL)">Delhi (DL)</option>
<option value="Jammu and Kashmir (JK)">Jammu and Kashmir (JK)</option>
<option value="Ladakh (LA)">Ladakh (LA)</option>
<option value="Lakshadweep (LD)">Lakshadweep (LD)</option>
<option value="Puducherry (PY)">Puducherry (PY)</option>

</select>
                  </div>
                  </div>
                  {/* Country */}
                 <div className="row mb-3">
    <div className="col">
                  <select
              className="form-control form-control-lg"
              name="country"
              value={formData.country}
              onChange={handleChange}
             
            >
              <option value="">Select Country</option>
              {countries.map((country) => (
                <option key={country} value={country}>
                  {country}
                </option>
              ))}
            </select>
                  </div>
                  {/* Zip */}
            <div className="col">
                    <input
                      // type="text"
                      className="form-control form-control-lg"
                      placeholder="Zip/Postal Code"
                      name="zip"
                      value={formData.zip}
                      onChange={handleChange}
                    />
                  </div>
                  </div>
                  {/* Password */}
                <div className="row mb-3">
  <div className="col position-relative">
    <input
      type={showPassword.password ? "text" : "password"}
      className="form-control form-control-lg pe-5"
      placeholder="Password*"
      name="password"
      value={formData.password}
      onChange={handleChange}
      required
    />
    <span
      className="position-absolute end-0 top-50 translate-middle-y me-3"
      onClick={() =>
        setShowPassword((prev) => ({
          ...prev,
          password: !prev.password,
        }))
      }
      style={{ cursor: "pointer" }}
    >
      <i
        className={`bi ${
          showPassword.password ? "bi-eye-slash" : "bi-eye"
        }`}
      ></i>
    </span>
  </div>
 <div className="col position-relative">
  <input
    type={showPassword.confirm ? "text" : "password"}
    className="form-control form-control-lg"
    placeholder="Confirm Password*"
    name="confirmPassword"
    value={formData.confirmPassword}
    onChange={handleChange}
    required
    style={{ position: "relative", zIndex: 1 }}
  />
  <span
    className="position-absolute end-0 top-50 translate-middle-y me-3"
    style={{ cursor: "pointer", zIndex: 2 }}
    onClick={() =>
      setShowPassword((prev) => ({
        ...prev,
        confirm: !prev.confirm,
      }))
    }
  >
    <i
      className={`bi ${showPassword.confirm ? "bi-eye-slash" : "bi-eye"}`}
    ></i>
  </span>
</div>

</div>
<div className="mb-3">
  {/* <label htmlFor="profile_pic" className="form-label">Profile Picture</label> */}
  <input
    type="file"
    className="form-control"
    id="profile_pic"
    name="profile_pic"
    accept="image/*"
    onChange={e => setFormData(prev => ({
      ...prev,
      profile_pic: e.target.files[0] || null
    }))}
  />
</div>
                  {/* Terms Checkbox */}
                  <div className="form-check mb-4">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="agree"
                      name="agree"
                      checked={formData.agree}
                      onChange={handleChange}
                      required
                    />
                    <label className="form-check-label" htmlFor="agree">
                      I agree to the <a href="#terms">Terms of User</a>
                    </label>
                  </div>
                <div className="d-flex justify-content-center">
  <button
    type="submit"
    className="btn btn-dark rounded-pill px-5 py-2"
    style={{ background: "#1C3F1D", color: "white" }}
  >
    {loading ? "Registering..." : "Register"}
  </button>
</div>

                </form>
            </div>

            {/* Right: Already Have Account */}
           <div className="col-md-5 ps-lg-5 d-flex flex-column justify-content-center align-items-center mt-5">
  <h3 className="mb-3 text-center">Already have an account?</h3>
  <p className="mb-4 text-muted text-center">
    Welcome back. Sign in to access your personalized experience, saved preferences, and more. We’re thrilled to have you with us again!
  </p>
  
  <button
    type="button"
     style={{background:'#1C3F1D',color:'white'}}
    className="btn  rounded-pill px-5 py-2"
    onClick={() => navigate("/login")}
  >
    Login
  </button>
</div>
          </div>
        </div>
      </div>
    </div>
    <hr/>
    </>

  );
};


export default Register;
